import React from 'react';
import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
import ContainerErrorBoundary from 'components/ContainerErrorBoundary/ContainerErrorBoundary';
var LoadableAdsWrapper = Loadable({
  loader: function loader() {
    return import('../AdsWrapper.jsx');
  },
  loading: ComponentLoading
});
export default function WrappedLoadable(props) {
  return /*#__PURE__*/React.createElement(ContainerErrorBoundary, null, /*#__PURE__*/React.createElement(LoadableAdsWrapper, props));
}